<template>
    <a-spin :tip="$t('Loading...')" :spinning="getting_data">
        <div>
            <navbar :back_path="back_path || '/inbox'" :navbar_sub_visible="$device != 'mobile'" active_screen="inbox" :content_title="inbox_detail.title" :hide_search="true" />
            <!-- section slides -->
            <div class="p-16" v-if="$device == 'mobile'">
                <div class="br-12">
                    <carousel ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#fff" paginationColor="rgba(128,128,128,0.5)" autoplay loop @page-change="handlePageChange">
                        <slide v-for="(slide, slide_index) in slides" :key="slide_index" class="slide" :data-index="slide_index + 1" :data-name="`slide-${slide_index + 1}`" @slideclick="handleSlideClick">
                            <img
                                class="br-12"
                                :src="slide.image_url"
                                :style="{
                                    width: $device == 'mobile' ? '100%' : '50%',
                                }"
                            />
                        </slide>
                    </carousel>
                    <div style="margin-top: 20px; justify-content: space-between; display: flex">
                        <label class="title">
                            {{ inbox_detail.title }}
                        </label>
                    </div>
                    <div style="margin: 16px 16px 0 16px" v-if="inbox_detail.description">
                        <label :class="`${read_all ? 'description-read-all' : 'description-read-all'}`" v-html="inbox_detail.description"> </label>
                    </div>
                    <div style="margin-top: 16px" v-if="inbox_detail.condition">
                        <label class="description" v-html="inbox_detail.condition"> </label>
                    </div>
                    <div v-for="(schedule, k) in inbox_detail.schedule" :key="k">
                        <div :class="`กางได้ fs-16 ${selected_schedule_info == k ? `` : `bg-gray`}`" @click="handleScheduleSelect(k)">
                            {{ schedule.title }}
                            <span :class="`fe fe-chevron-${selected_schedule_info == k ? `up` : `down`} fs-20`" style="float: right; line-height: 64px" />
                        </div>
                        <div v-if="selected_schedule_info == k" style="margin-top: 16px">
                            <label class="description" v-html="schedule.detail"> </label>
                        </div>
                    </div>
                    <div class="text-center" style="margin: 0; margin-top: 32px; padding-bottom: 16px">
                        <a-button v-if="inbox_detail.display_button && !error_6_3" size="large" class="text-center primary-btn ant-button-label-custom fs-16" style="border-radius: 0; width: 144px" @click="onRegister">
                            <strong>สมัคร</strong>
                        </a-button>
                    </div>
                </div>
            </div>
            <div style="padding: 8px" v-else>
                <div style="background-color: #fff">
                    <div class="row">
                        <div class="col-5">
                            <carousel ref="carousel" :per-page="1" paginationPosition="bottom-overlay" paginationActiveColor="#fff" paginationColor="rgba(128,128,128,0.5)" autoplay loop @page-change="handlePageChange">
                                <slide v-for="(slide, slide_index) in slides" :key="slide_index" class="slide" :data-index="slide_index + 1" :data-name="`slide-${slide_index + 1}`" @slideclick="handleSlideClick">
                                    <!-- <img
                                        :src="slide.image_url"
                                        :style="{
                                            width: $device == 'mobile' ? '100%' : '50%',
                                        }"
                                    /> -->
                                    <img :src="slide.image_url" style="width: 100%; margin: 32px 0 0 32px" />
                                </slide>
                            </carousel>
                        </div>
                        <div class="col-7">
                            <div style="margin-top: 20px; justify-content: space-between; display: flex">
                                <label class="title">
                                    {{ inbox_detail.title }}
                                </label>
                            </div>
                            <div style="margin: 16px 16px 0 16px" v-if="inbox_detail.description">
                                <label :class="`${read_all ? 'description-read-all' : 'description-read-all'}`" v-html="inbox_detail.description"> </label>
                            </div>
                            <div style="margin-top: 16px" v-if="inbox_detail.condition">
                                <label class="description" v-html="inbox_detail.condition"> </label>
                            </div>
                            <div v-for="(schedule, k) in inbox_detail.schedule" :key="k">
                                <div :class="`กางได้ fs-16 ${selected_schedule_info == k ? `` : `bg-gray`}`" @click="handleScheduleSelect(k)">
                                    {{ schedule.title }}
                                    <span :class="`fe fe-chevron-${selected_schedule_info == k ? `up` : `down`} fs-20`" style="float: right; line-height: 64px" />
                                </div>
                                <div v-if="selected_schedule_info == k" style="margin-top: 16px">
                                    <label class="description" v-html="schedule.detail"> </label>
                                </div>
                            </div>
                            <div class="text-center" style="margin: 0; margin-top: 32px; padding-bottom: 16px">
                                <a-button v-if="inbox_detail.display_button && !error_6_3" size="large" class="text-center primary-btn ant-button-label-custom fs-16" style="border-radius: 0; width: 144px" @click="onRegister">
                                    <strong>สมัคร</strong>
                                </a-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <modal-form ref="modalForm" :key="modal_visible" :visible="modal_visible" :data="modal_data" @on-save="onModalSave" @on-cancel="onModalCancel" />
        </div>
    </a-spin>
</template>
<script>
import navbar from '../../components/navbar';
import { Carousel, Slide } from 'vue-carousel';
import modalForm from './modalForm';
import moment from 'moment';
export default {
    components: {
        navbar,
        Carousel,
        Slide,
        modalForm,
    },
    data: function () {
        return {
            form: this.$form.createForm(this),
            slides: [],
            inbox_detail: {},
            getting_data: true,
            display_read_all: false,
            read_all: false,
            inbox_id: this.$route.query.inbox_id,
            back_path: this.$route.query.back_path,
            step: 'register',
            modal_visible: false,
            modal_data: {},
            activity_apply: {},
            user: this.$store.state.user,
            date: moment(new Date()).format('LL'),
            group_selected: [],
            radio_type: '',
            error_6_3: false,
            selected_schedule_info: null,
            กาง: false,
        };
    },
    mounted() {
        this._mounted();
    },
    methods: {
        moment,
        _mounted: function () {
            this.getInboxDetail(() => (this.getting_data = false));
        },
        getInboxDetail: function (callback = null) {
            this.$store.dispatch('user/POST', {
                payload: {
                    path: '/api/news/detail',
                    data: {
                        id: this.inbox_id,
                    },
                    callback: (res) => {
                        if (res) {
                            this.inbox_detail = res;
                            if (this.inbox_detail.description.length > 155) this.display_read_all = true;
                            this.slides.push({
                                image_url: res.image,
                            });
                            if (typeof callback == 'function') callback();
                        } else if (typeof callback == 'function') callback();
                    },
                },
            });
        },
        toggleFavorite(inbox_detail) {
            var url;
            if (!inbox_detail.button_favorite) {
                url = '/api/favorite/delete';
            } else {
                url = '/api/favorite/add';
            }
            this.getting_data = true;
            this.$store.dispatch('user/POST', {
                payload: {
                    path: url,
                    data: {
                        xid: inbox_detail.id,
                        type: 'news',
                    },
                    callback: (res) => {
                        console.log('res', res);
                        if (res && res.result == 'complete') {
                            this.getInboxDetail();
                        } else {
                            const complete = {
                                title: '',
                            };
                            for (const [key, value] of Object.entries(res.errors)) {
                                if (key) {
                                    console.log('value[0]', value[0]);
                                    complete.title += value[0];
                                }
                            }
                            this.$confirm({
                                title: complete.title,
                                button: {
                                    yes: 'ปิดหน้าต่าง',
                                },
                                callback: (confirm) => {},
                            });
                        }
                        this.getting_data = false;
                    },
                },
            });
        },
        selectGroup(display_order) {
            if (this.group_selected.indexOf(display_order) == -1) {
                this.group_selected.push(display_order);
            } else {
                this.group_selected = this.group_selected.filter((v) => v != display_order);
            }
            console.log('this.group_selected', this.group_selected);
        },
        handlePageChange(page) {
            this.current_page = page;
        },
        onReadAll() {
            this.display_read_all = false;
            this.read_all = true;
        },
        registerCheckApply() {
            this.getting_data = true;
            if (this.inbox_detail && this.inbox_detail.accom_limit == 0) {
                this.registerApply();
            } else {
                this.$store.dispatch('user/POST', {
                    payload: {
                        path: '/api/activity/check/apply',
                        data: {
                            id: this.inbox_detail.id,
                        },
                        callback: (res) => {
                            if (res && res.result == 'complete') {
                                this.registerApply();
                            } else {
                                this.error_6_3 = true;
                                const complete = {
                                    title: '',
                                };
                                for (const [key, value] of Object.entries(res.errors)) {
                                    if (key) {
                                        console.log('value[0]', value[0]);
                                        complete.title += value[0];
                                    }
                                }
                                this.$confirm({
                                    message: complete.title,
                                    button: {
                                        yes: 'ปิดหน้าต่าง',
                                    },
                                    callback: (confirm) => {},
                                });
                            }
                            this.getting_data = false;
                        },
                    },
                });
            }
        },
        registerApply() {
            var data = {
                id: this.inbox_detail.id,
            };
            if (this.group_selected.length) {
                this.group_selected.forEach((group_id, key) => {
                    data['group_choose' + Number(key + 1)] = group_id;
                });
            } else {
                if (this.inbox_detail.group.length) {
                    this.inbox_detail.group.forEach((group, key) => {
                        if (key == 0) {
                            data['group_choose' + Number(key + 1)] = group.display_order;
                        }
                    });
                }
            }
            this.form.validateFields((err, values) => {
                if (!err) {
                    if (values.follower) {
                        data.accoms = [];
                        for (let i = 0; i < values.follower; i++) {
                            data.accoms.push({
                                prefix_name: null,
                                first_name: null,
                                last_name: null,
                                age: null,
                                member_id: null,
                                relationship: null,
                                tel: null,
                                remark: null,
                            });
                        }
                    }
                    this.getting_data = true;
                    this.$store.dispatch('user/POST', {
                        payload: {
                            path: '/api/activity/apply',
                            data: data,
                            callback: (res) => {
                                if (res && res.result == 'complete') {
                                    this.step = 'register_success';
                                    this.modal_visible = true;
                                    this.modal_data.step = 'register_success';
                                    this.modal_data.message = 'คุณได้ลงทะเบียนเรียบร้อยแล้ว';
                                    this.activity_apply = res.complete.data;
                                } else {
                                    const complete = {
                                        title: '',
                                    };
                                    for (const [key, value] of Object.entries(res.errors)) {
                                        if (key) {
                                            console.log('value[0]', value[0]);
                                            complete.title += value[0];
                                        }
                                    }
                                    this.$confirm({
                                        message: complete.title,
                                        button: {
                                            yes: 'ปิดหน้าต่าง',
                                        },
                                        callback: (confirm) => {},
                                    });
                                }
                                this.getting_data = false;
                            },
                        },
                    });
                }
            });
        },
        onRegister() {
            this.modal_visible = true;
            this.modal_data.step = 'register';
        },
        onModalSave() {
            this.modal_visible = false;
            if (this.inbox_detail.atype_name == 'ทัวร์') {
                this.step = 'activity_select_group';
            } else {
                this.registerApply();
            }
        },
        onModalCancel() {
            this.modal_visible = false;
        },
        handleSlideClick(dataset) {
            console.log(dataset.index, dataset.name);
        },
        handleScheduleSelect(key) {
            if (this.selected_schedule_info == key) this.selected_schedule_info = null;
            else this.selected_schedule_info = key;
        },
        toMoment(date_unix) {
            return this.mtby(moment.unix(date_unix), 'LL');
        },
    },
};
</script>
<style scoped>
.badge-icon {
    position: absolute;
    top: 3px;
    right: 200px;
    background: url('../../../public/resources/images/follower-badge.png');
    background-size: 100%;
    width: 40px;
    height: 40px;
}
.badge-label {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    text-align: center;
    color: #000 !important;
    line-height: 40px;
    font-size: 14px;
}
.custom-card {
    margin: 16px;
    background-color: #fff;
    border-radius: 8px;
}
.custom-close {
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    color: #707070 !important;
    text-align: right;
    opacity: 0.5;
}
.slide {
    background-color: transparent;
    width: 100%;
    text-align: center;
}
.image {
    width: 100%;
}
.title {
    font-size: 20px;
    font-weight: 600;
    margin: 8px 0 0 16px;
    color: #cc0000 !important;
}
.description {
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    /* color: #707070 !important; */
}
.description-read-all {
    font-size: 16px;
    font-weight: 300;
    margin: 0;
    /* color: #707070 !important; */
}
.read-all {
    font-size: 14px;
    font-weight: 300;
    margin: 8px 0 8px 0;
    color: #707070 !important;
}
.half-circle {
    width: 50px;
    height: 25px; /* as the half of the width */
    background-color: #fff;
    border-bottom-left-radius: 25px;
    border-bottom-right-radius: 25px;
    /* border: 10px solid gray; */
    border-top: 0;
    box-shadow: #707070 0px 25px 40px 0px;
    margin: 0 auto;
}
/* .vue-confirm-dialog {
}
.vue-confirm-dialog .vc-container .vc-text-grid .vc-title {
  font-size: 16px !important;
}
.vc-title {
  font-size: 16px !important;
} */
.กางได้ {
    width: 90%;
    min-height: 64px;
    line-height: 64px;
    background: linear-gradient(0deg, #af2e30, #e05a61 100%) no-repeat;
    margin: 8px auto;
    color: #fff;
    font-weight: 300;
    padding: 0 16px;
}
.bg-gray {
    background: linear-gradient(0deg, #4b4b4b, #bbbbbb 100%) no-repeat;
}
</style>